import { useState } from 'react';
import { Tabs } from 'antd';
import ConnectionStatus from './components/WhatsAppConnectionStatus';
import MessageLogs from './components/WhatsAppMessageLogs';
import WhatsAppGroupManager from './components/WhatsAppGroupManager';

export default function WhatsAppControlPanel() {
	const [connectionStatus, setConnectionStatus] = useState();
	const [refreshData, setRefreshData] = useState(true);
	const [searchString, setSearchString] = useState('');

	const searchGroupList = (groupName) => {
		setSearchString(groupName);
	};

	const items = [
		{
			key: 'panel',
			label: 'Control Panel',
			children: (
				<>
					<ConnectionStatus
						connectionStatus={connectionStatus}
						setConnectionStatus={setConnectionStatus}
						updateGroupList={searchGroupList}
					/>
					<WhatsAppGroupManager
						connectionStatus={connectionStatus}
						refreshData={refreshData}
						setRefreshData={setRefreshData}
						searchGroup={searchString}
					/>
				</>
			),
		},
		{
			key: 'logs',
			label: 'Logs',
			children: <MessageLogs />,
		},
	];

	return <Tabs items={items} size="small" />;
}
